import React, { useState, useEffect, useRef } from "react";
import { Link } from 'react-router-dom';
import $ from "jquery";
import axiosInstance from "../../services/api";
import "datatables.net";
import "../../../node_modules/datatables.net-dt/css/dataTables.dataTables.min.css";
import "datatables.net-responsive-dt";
import "../../../node_modules/datatables.net-responsive-dt/css/responsive.dataTables.min.css";
import "jquery-ui-dist/jquery-ui.css";
import "jquery-ui-dist/jquery-ui";
import Select from "react-select";
import Loader from '../Commons/Loader';
function DownloadReport() {
    const tableRef = useRef(null);
    const [reportListData, setReportListData] = useState([]);
    const startDatepickerRef = useRef(null);
    const endDatepickerRef = useRef(null);
    const [startDate, setStartDate] = useState("");
    const [endDate, setEndDate] = useState("");
    const [hotelId, setHotelId] = useState("");
    const [hotelListData, setHotelListData] = useState([]);
    const [placeholder, setPlaceholder] = useState("Please Select Hotel Id");
    const [loading, setLoading] = useState(true);
    const [errorMessage, setErrorMessage] = useState(""); 
    const [onChangeKey, setOnChangeKey] = useState("false");
    const [propertyName, setPropertyName] = useState("");
    // Fetch hotel data
    const fetchDataHotel = async () => {
        try {
            const response = await axiosInstance.get('hotel/all-hotels.json');
            setHotelListData(response.data.data || []);
        } catch (error) {
            console.error('Error fetching hotel data:', error);
        }finally {
            setLoading(false);
          }
    };

    useEffect(() => {
        fetchDataHotel();
    }, []);

    // Initialize datepickers
    useEffect(() => {
        const today = new Date();

        $(startDatepickerRef.current).datepicker({
            dateFormat: "yy-mm-dd",
            maxDate: today,
            onSelect: (selectedDate) => {
                $(endDatepickerRef.current).datepicker("option", "minDate", selectedDate);
                setStartDate(selectedDate);
            },
        });

        $(endDatepickerRef.current).datepicker({
            dateFormat: "yy-mm-dd",
            maxDate: today,
            onSelect: (selectedDate) => {
                $(startDatepickerRef.current).datepicker("option", "maxDate", selectedDate);
                setEndDate(selectedDate);
            },
        });
    }, []);

    // const options = hotelListData.map((item) => ({
    //     value: item.id,
    //     label: item.hotelName,
    // }));
    const options = [
        { value: "all", label: "All Hotels" }, // manually add "All"
        ...hotelListData.map((item) => ({
            value: item.id,
            label: item.hotelName,
        })),
    ];
    console.log(hotelId,"hotelId")

    const customStyles = {
        control: (provided) => ({
            ...provided,
            minHeight: "40px",
        }),
        menu: (provided) => ({
            ...provided,
            zIndex: 9999,
        }),
    };

    const handleSelectChange = (e) => {
        setHotelId(e.value);
        setOnChangeKey("true");
        setPropertyName(e.label);
    };

    // Initialize or reinitialize DataTable
    const initializeDataTable = () => {
        if ($.fn.DataTable.isDataTable(tableRef.current)) {
            $(tableRef.current).DataTable().destroy();
        }

        $(tableRef.current).DataTable({
            data: reportListData.map((item) => [
                item.hotelId,
                item.hotelName,
                item.reportDate,
                item.status,
                item.missingReports,
            ]),
            columns: [
                { title: "Hotel Id" },
                { title: "Hotel Name" },
                { title: "Report Date" },
                { title: "Status" },
                { title: "Missing Reports" },
            ],
            paging: true,
            searching: true,
            lengthChange: true,
            ordering: true,
            responsive: {
                   
            },
            columnDefs: [
                { targets: 1, responsivePriority: 1 }, // Name - Always visible
                { targets: 2, responsivePriority: 2 }, // Operations - Always visible
                { targets: [1, 2, 3], responsivePriority: 2 } 
                
            ],
        });
    };

    // Reinitialize DataTable when reportListData changes
    useEffect(() => {
        if (reportListData.length > 0) {
            initializeDataTable();
        }
    }, [reportListData]);
    useEffect(() => {
        const handleResize = () => {
            if ($.fn.DataTable.isDataTable(tableRef.current)) {
                $(tableRef.current).DataTable().columns.adjust().responsive.recalc();
            }
        };
        window.addEventListener("resize", handleResize);
        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []);

    const handleSubmit = async (format) => {
        //e.preventDefault();
        setLoading(true);

        try {
            setLoading(true);
            const response = await axiosInstance.get(
                `incidents/export-report?hotelId=${hotelId}&startDate=${startDate}&endDate=${endDate}&sendToEmail=false`,
                {
                    responseType: "blob", // Handle binary data correctly
                    timeout: 120000, // Timeout set to 120 seconds (120000 ms)
                }
            );
          const contentType = response.headers["content-type"] || (format === "pdf" ? "application/pdf" : "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet");
      
          // Create a Blob from the response data
          const blob = new Blob([response.data], { type: contentType });
      
          // Generate a temporary URL for the file
          const downloadUrl = window.URL.createObjectURL(blob);
      
          // Create a hidden <a> element to trigger the download
          const link = document.createElement("a");
          link.href = downloadUrl;
          
        //   const capitalizedGroup = selectedGroup.charAt(0).toUpperCase() + selectedGroup.slice(1).toLowerCase();
          const today = new Date();
          // Format date and time for file name
          const formattedDate = today.toISOString().split('T')[0];
          const hours = today.getHours().toString().padStart(2, '0');
          const minutes = today.getMinutes().toString().padStart(2, '0');
          const seconds = today.getSeconds().toString().padStart(2, '0');
          const currentTime = `${formattedDate}-${hours}-${minutes}-${seconds}`;
      
          const DownloadFileName = `Report-${propertyName}-${currentTime}.${format}`;
          link.setAttribute("download", DownloadFileName);
      
          document.body.appendChild(link);
          link.click();
      
          // Cleanup
          document.body.removeChild(link);
          window.URL.revokeObjectURL(downloadUrl);
        } catch (error) {
            console.error("Error fetching report data:", error);
        } finally {
            setLoading(false);
        }
    };
    const isDisabled = onChangeKey==="false" || !startDate || !endDate || hotelId==="" ;
    return (
        <>
            {loading && <Loader />} 
                <div className="content-header">
                    <div className="container-fluid">
                        <div className="row mb-2">
                            <div className="col-sm-6">
                                <h1 className="m-0">Download Report</h1>
                            </div>
                            <div className="col-sm-6">
                                <ol className="breadcrumb float-sm-right">
                                    <li className="breadcrumb-item"><Link to="/dashboard">Dashboard</Link></li>
                                    <li className="breadcrumb-item active">Download Report</li>
                                </ol>
                            </div>
                        </div>
                    </div>
                </div>
                <section className="content">
                    <div className="container-fluid border-top pt-4">
                        <div className='usage-report-section'>
                            <div className='usage-report-top'>
                                <div className='row'>
                                    <div className="col-lg-3 mb-mob">
                                        <label htmlFor="" className="mb-2">From</label>
                                        <input
                                            type="text"
                                            placeholder="Start Date"
                                            className="input-fld"
                                            ref={startDatepickerRef}
                                            onKeyDown={(e) => {
                                                if (e.key === "Backspace") {
                                                    e.preventDefault(); // Disable backspace functionality
                                                }
                                            }}
                                        />
                                    </div>
                                    <div className="col-lg-3 mb-mob">
                                        <label htmlFor="" className="mb-2">To</label>
                                        <input
                                            type="text"
                                            placeholder="End Date"
                                            className="input-fld"
                                            ref={endDatepickerRef}
                                            onKeyDown={(e) => {
                                                if (e.key === "Backspace") {
                                                    e.preventDefault(); // Disable backspace functionality
                                                }
                                            }}
                                        />
                                    </div>
                                </div>
                                <div className='row mt-10'>
                                    <div className="col-lg-3 mb-mob">
                                        <label htmlFor="" className="mb-2">Property</label>
                                        <Select
                                            options={options}
                                            onChange={handleSelectChange}
                                            placeholder={placeholder}
                                            styles={customStyles}
                                            isSearchable
                                            noOptionsMessage={() => "No sub-hotels available"}
                                        />
                                    </div>
                                </div>
                                <div className="row mt-10">
                                    <div className="col-4">
                                        <button
                                            onClick={() => handleSubmit("xlsx")}
                                            className="btn btn-primary submit-btn search-btn"
                                            disabled={isDisabled}
                                        >
                                            Download Report
                                        </button>
                                    </div>
                                </div>
                            </div>
                            
                                <table
                                    ref={tableRef}
                                    className="display styled-table report-verification-table"
                                ></table>
                                {errorMessage && <p className="error-msg" style={{ color: 'red' }}>{errorMessage}</p>}
                        </div>
                    </div>
                </section>
        </>
    );
}

export default DownloadReport;
